import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { useFormContext } from 'react-hook-form'

import { CheckboxCell } from '@cash-design-system/react'
import { ArcadeAvatarFromUiAvatar } from '@cash-web/avatar-from-proto'
import { FormBlockerElementCheckBoxElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

export const getCheckboxElementKey = (formSectionIndex: number) => `${formSectionIndex}.check_box_result.is_checked`

const CellImage = styled.img`
  height: 3rem;
  width: 3rem;
  object-fit: contain;
`

export const CheckboxElement = ({
  formSectionIndex,
  text,
  default_value,
  is_required,
  avatar,
  image,
  fulfills_requirements,
  validation_message,
}: FormBlockerElementCheckBoxElement & { formSectionIndex: number }) => {
  const { register } = useFormContext()
  const theme = useTheme()

  const inputName = getCheckboxElementKey(formSectionIndex)
  const { ref, ...rest } = register(inputName, {
    required: !!is_required,
  })

  return (
    <CheckboxCell
      label={text ?? ''}
      defaultChecked={default_value}
      {...rest}
      ref={ref}
      cellProps={
        avatar || image
          ? {
              asset: {
                avatar: avatar ? (
                  <ArcadeAvatarFromUiAvatar uiAvatar={avatar} size="small" />
                ) : (
                  <CellImage src={theme.darkMode ? image?.dark_url ?? image?.light_url : image?.light_url} />
                ),
              },
            }
          : undefined
      }
    />
  )
}
